import { combineReducers } from "redux";

import types from "./types";

const productCategoryMixEmpty = {
    loading: false,
    error: false,
    store: [],
    comparator: []
};

const productCategoryMix = (state = productCategoryMixEmpty, action) => {
    switch (action.type) {
        case types.GET_PRODUCT_CATEGORY_MIX_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
                store: [],
                comparator: []
            };
        case types.GET_PRODUCT_CATEGORY_MIX_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                store: action.payload.store,
                comparator: action.payload.comparator
            };
        case types.GET_PRODUCT_CATEGORY_MIX_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
                store: [],
                comparator: []
            };
        default:
            return state;
    }
};

const reducer = combineReducers({
    productCategoryMix
});

export default reducer;
